class ResponsiveVideoBackground extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    const desktopTemplate = this.querySelector(
      '[data-video-template-desktop]'
    );

    const mobileTemplate = this.querySelector(
      '[data-video-template-mobile]'
    );

    const breakpoint = window.theme?.sizes?.small || 750;
    const isMobile = window.innerWidth < breakpoint;

    let selectedTemplate;

    if (isMobile && mobileTemplate) {
      selectedTemplate = mobileTemplate;
    } else if (desktopTemplate) {
      selectedTemplate = desktopTemplate;
    } else {
      selectedTemplate = mobileTemplate;
    }

    if (!selectedTemplate) return;

    const videoBackground = document.createElement('video-background');

    videoBackground.classList.add('video__player', 'is-loading');

    videoBackground.setAttribute('data-video-player', '');

    videoBackground.setAttribute(
      'data-video-id',
      this.dataset.videoId
    );

    const template = document.createElement('template');

    template.setAttribute('data-video-template', '');
    template.innerHTML = selectedTemplate.innerHTML;

    videoBackground.appendChild(template);

    this.replaceWith(videoBackground);
  }
}

if (!customElements.get('responsive-video-background')) {
  customElements.define(
    'responsive-video-background',
    ResponsiveVideoBackground
  );
}